import React, { useState } from "react";
import styles from "./GroupUpdate.module.css";
import OnlyDropDown from "../../components/OnlyDropDown/OnlyDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice"; // adjust path as needed

const GroupUpdate = () => {
  const dispatch = useDispatch();

  const [selectedGroup, setSelectedGroup] = useState("");

  const groupOptions = ["Group A", "Group B", "Group C", "Group D"];

  const handleUpdate = () => {
    if (!selectedGroup) {
      alert("Please select a group");
      return;
    }
    console.log("Group updated to:", selectedGroup);
    // Optionally dispatch to backend or redux here
    dispatch(closeModal());
  };

  const handleCancel = () => {
    console.log("Group update canceled");
    dispatch(closeModal());
  };

  return (
    <div className={styles.modalContainer}>
      <div className={styles.modalHeader}>Select Group</div>
      <div className={styles.modalBody}>
        <OnlyDropDown
          label="Choose Group"
          name="group"
          value={selectedGroup}
          options={groupOptions}
          onChange={(e) => setSelectedGroup(e.target.value)}
        />
      </div>
      <div className={styles.modalFooter}>
        <SaveAndCancel
          onCancel={handleCancel}
          onSave={handleUpdate}
          cancelLabel="Cancel"
          saveLabel="Update"
        />
      </div>
    </div>
  );
};

export default GroupUpdate;
